<template>
    <div class="widget-wrapper" v-show="isVisible"
        :class="{ 'collapsed': isCollapsed, 'expanded': !isCollapsed && !isInInitialState, 'closedisi': closeIsiPan }">
        <div class="widget" id="widget">
            <div class="scrollable"  @scroll="handleScroll" v-if="!isCollapsed">
                <div class="scrollable_content">
                </div>
            </div>
            <div class="collapse-head container" :data-label='dataLabel' data-category='Global ISI' @click="collapse"
                @click.stop>
                <div class="d-flex justify-content-end" :data-label='dataLabel' data-category='Global ISI'>
                    <div class="d-flex justify-content-between align-items-center head-content">
                        <span class="pt-0 pb-0 m-0" :data-label='dataLabel' data-category='Global ISI'>{{ title
                            }}</span>
                        <i v-show="isCollapsed" :data-label="openLabel" data-category='Global ISI'
                            class="fas fa-plus"></i>
                        <i v-show="!isCollapsed" :data-label="closeLabel" data-category='Global ISI'
                            class="fas fa-minus"></i>
                    </div>

                </div>

            </div>
            <div class="blue-line"></div>
            <div class="widget-content" id="widget-content">
                <irsh-indication :hideTitle="false"></irsh-indication>
            </div>
        </div>

    </div>
</template>

<script>
import DataList from '../models/dataList'
import { mapState } from "vuex"
const HEIGHT_SCROLL_BLOCK = 0;
const openISILabel = 'Open - ISI'
const closeISILabel = 'Close - ISI'

export default {
    props: ['text'],
    computed: {
        ...mapState(['indicationPos']),
    },
    data() {
        return {
            isVisible: true,
            isCollapsed: true,
            isInInitialState: true,
            list: DataList.differentDeliveryPage().widgetList,
            card: DataList.differentDeliveryPage().card,
            dataLabel: openISILabel,
            openLabel: openISILabel,
            closeLabel: closeISILabel,
            closeIsiPan: false,
            title: 'Expand'
        }
    },
    mounted() {
        this.isVisible = true
        setTimeout(() => {
            if (this.allowHideWidget()) {
                this.isVisible = false
            } else {
                this.isVisible = true
            }

        }, 0);
        let isClosed = (localStorage.getItem('journayisiclosed') === 'true') || false;
        if (isClosed) {
            this.closeIsiPan = true
            this.isCollapsed = true
        }
        this.$root.$on('is-widget', () => {
            console.log('enter is widget')
            this.isCollapsed = true
            this.isInInitialState = true
        })
        this.$root.$on('show-widget', (data) => {
            console.log(data)
            if (data) {
                this.isCollapsed = false
                this.isInInitialState = false
                this.closeIsiPan = false
                document.body.style.overflowY = 'hidden';
                localStorage.setItem('journayisiclosed', 'false');
            }
        })
        let scrollPos = 0
        window.addEventListener('scroll', (ev) => {
            scrollPos = (document.body.getBoundingClientRect()).top
            if (window.pageYOffset > 0) {
                this.isInInitialState = false
            }
            if (this.allowHideWidget()) {
                this.isVisible = false
            } else {
                this.isVisible = true
            }

        })
        this.$root.$on("toggle-widget", () => {
            if(this.isVisible){
                this.collapse();
            } else {
                document.getElementById("indication").scrollIntoView({ behavior: "smooth" });

            }
        });

        if (!localStorage.getItem('journayisiclosed')) {
            this.collapse();
        }
    },
    methods: {
        height() {
            if (window.innerHeight < 600) {
                return 150
            } else {
                return 500
            }
        },
        collapse() {
            this.isCollapsed = !this.isCollapsed
            this.isInInitialState = false
            if (!this.isCollapsed) {
                document.body.style.overflowY = 'hidden';
                this.closeIsiPan = false;
                localStorage.setItem('journayisiclosed', 'false');
            } else {
                document.body.style.overflowY = 'visible';
                this.closeIsiPan = true;
                localStorage.setItem('journayisiclosed', 'true');
            }
        },
        allowHideWidget() {
            return (
                (document.querySelector('#indication').offsetTop
                    + HEIGHT_SCROLL_BLOCK)
                <= window.pageYOffset + window.innerHeight
            )
        },
        closeisi() {
            this.isVisible = false;
        },
        handleScroll(event) {
            this.collapse();
        }
    },
    watch: {
        isCollapsed: function (newValue) {
            this.title = newValue ? 'Expand' : 'Collapse';
            this.dataLabel = !newValue ? this.closeISILabel : this.openISILabel;

            if (newValue) {
                const widgetContent = document.querySelector('.widget-content');
                widgetContent.scrollTop = 0;
            }

            this.$nextTick(() => {
                const widget = document.getElementById('widget');
                if (widget) {
                    widget.classList.remove('widget-collapse', 'widget-expand');
                    widget.classList.add(newValue ? 'widget-collapse' : 'widget-expand');
                }

                setTimeout(() => {
                    if (widget.classList.contains('widget-expand')) {
                        widget.classList.add('active');
                    }
                }, 10);
            });
        }
    },
    beforeDestroy() {
        this.$root.$off("toggle-widget");
    },

}
</script>
